<!-- Loader shows when LoaderService emits visible=true -->
<div *ngIf="isVisible" class="loader-overlay" role="status" aria-live="polite">
    <div class="spinner" aria-hidden="true"></div>
    <div *ngIf="message" class="loader-message">{{ message }}</div>
</div>